var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qld-component-player',{attrs:{"data-qld-config":_vm.playerQldConfigAsString,"data-qld-name":"player"},on:{"player-loaded":_vm.playerReady}})}
var staticRenderFns = []

export { render, staticRenderFns }